import { z } from "zod";
import { NOTE_COLORS } from "./theme";

export const createCalendarSchema = z.object({
  name: z.string().trim().min(1).max(80),
  color: z.enum(NOTE_COLORS).optional(),
  teamId: z.string().uuid().nullish(),
  isDefault: z.boolean().optional(),
});

const isoDate = z.string().datetime({ offset: true });

export const createEventSchema = z
  .object({
    calendarId: z.string().uuid(),
    title: z.string().trim().min(1).max(300),
    description: z.string().max(10_000).nullish(),
    location: z.string().max(300).nullish(),
    startsAt: isoDate,
    endsAt: isoDate,
    allDay: z.boolean().optional(),
    /** RFC 5545 RRULE, without the `RRULE:` prefix. */
    rrule: z.string().max(500).nullish(),
    color: z.enum(NOTE_COLORS).optional(),
    noteId: z.string().uuid().nullish(),
  })
  .refine((v) => new Date(v.endsAt) >= new Date(v.startsAt), {
    message: "endsAt must not be before startsAt",
    path: ["endsAt"],
  });

export const updateEventSchema = z
  .object({
    calendarId: z.string().uuid().optional(),
    title: z.string().trim().min(1).max(300).optional(),
    description: z.string().max(10_000).nullish(),
    location: z.string().max(300).nullish(),
    startsAt: isoDate.optional(),
    endsAt: isoDate.optional(),
    allDay: z.boolean().optional(),
    rrule: z.string().max(500).nullish(),
    color: z.enum(NOTE_COLORS).optional(),
    noteId: z.string().uuid().nullish(),
  })
  .refine(
    (v) => !(v.startsAt && v.endsAt) || new Date(v.endsAt) >= new Date(v.startsAt),
    { message: "endsAt must not be before startsAt", path: ["endsAt"] },
  );

export const eventRangeSchema = z.object({
  from: isoDate,
  to: isoDate,
  calendarId: z.string().uuid().optional(),
});

export type CreateEventInput = z.infer<typeof createEventSchema>;
export type UpdateEventInput = z.infer<typeof updateEventSchema>;
